
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_6378_174)"}},[_c('path',{attrs:{"d":"M12 23.5L3.23737 12L12 0.5L20.7626 12L12 23.5Z","fill":"#E31377"}}),_c('path',{attrs:{"d":"M20.7626 12L12 23.5L3.23737 12H20.7626Z","fill":"#C9116A"}}),_c('path',{attrs:{"d":"M4.346 12L12 23.5L3.23737 12H4.346Z","fill":"#B50F5F"}}),_c('path',{attrs:{"d":"M4.346 12L12 0.5L3.23737 12H4.346Z","fill":"#E34490"}}),_c('path',{attrs:{"d":"M17.7211 12L12 23.5L6.2789 12H17.7211Z","fill":"#FD4772"}}),_c('path',{attrs:{"d":"M16.0483 12L12 23.5L7.95172 12H16.0483Z","fill":"#FF75C2"}}),_c('path',{attrs:{"d":"M16.0483 12L12 23.5V12H16.0483Z","fill":"#FF8FCD"}}),_c('path',{attrs:{"d":"M17.7211 12L12 0.5L6.2789 12H17.7211Z","fill":"#FD819E"}}),_c('path',{attrs:{"d":"M16.0483 12L12 0.5L7.95172 12H16.0483Z","fill":"#FFD1FD"}}),_c('path',{attrs:{"d":"M12 12V0.5L7.95172 12H12Z","fill":"#FFB0E7"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_6378_174"}},[_c('rect',{attrs:{"width":"17.5253","height":"23","fill":"white","transform":"translate(3.23737 0.5)"}})])])])
          )
        }
      }
    